import ups from "../assets/ups.svg";

const ShippingUPSBox = (props) => {
  const weather = Array.isArray(props.weather) ? props.weather : [];
  const stringDate = props.expectedDelivery || "";

  const parseDeliveryDate = (value) => {
    if (!value || typeof value !== "string") {
      return null;
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [year, month, day] = value.split("-").map(Number);
      return new Date(year, month - 1, day);
    }

    if (/^\d{8}$/.test(value)) {
      const year = Number(value.substring(0, 4));
      const month = Number(value.substring(4, 6));
      const day = Number(value.substring(6, 8));
      return new Date(year, month - 1, day);
    }

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      return null;
    }
    return parsed;
  };

  const deliveryDate = parseDeliveryDate(stringDate);
  const stringDateFormatted = deliveryDate
    ? `${deliveryDate.getFullYear()}-${String(deliveryDate.getMonth() + 1).padStart(2, "0")}-${String(deliveryDate.getDate()).padStart(2, "0")}`
    : "Unknown";

  let min = 100;
  let max = 0;

  if (deliveryDate) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const deliveryDay = new Date(deliveryDate);
    deliveryDay.setHours(0, 0, 0, 0);
    const daysBetween = Math.ceil((deliveryDay - today) / 86400000);

    weather.forEach((day, i) => {
      if (i < daysBetween + 1 && day?.temp) {
        if (day.temp.min < min) {
          min = day.temp.min;
        }
        if (day.temp.max > max) {
          max = day.temp.max;
        }
      }
    });
  }

  return (
    <div className="w-full max-w-sm rounded-xl bg-neutral-50 p-6 shadow-sm">
      <div className="flex content-center justify-center pb-3">
        <img src={ups} alt="ups logo" className="h-8 w-10 m-3" />
        <h1 className="m-auto text-xl font-bold text-slate-700">
          {props.service}
        </h1>
      </div>
      <h3 className="text-lg text-slate-700">
        Expected Delivery: {stringDateFormatted}
      </h3>
      {min < (props.low) && (
        <h4 className="text-xl font-semibold text-red-800">Do Not Ship</h4>
      )}
      {min > props.high && (
        <h4 className="text-xl font-semibold text-green-500">Safe To Ship</h4>
      )}
      {/* {min+3 < props.low  && min-3 > props.low && (
        <h4 className="text-xl font-semibold text-green-500">Marginal</h4>
      )} */}

      {min < props.high && min > props.low && (
        <h4 className="text-xl font-semibold text-red-500">
          Insulation Needed
        </h4>
      )}
      <h5 className="text-md italic  text-slate-700">
        Low:{" "}
        {props.tempUnit ? (
          <span>{min} °F</span>
        ) : (
          <span>{Math.round(((min - 32) * 5) / 9)} °C</span>
        )}{" "}
        High:{" "}
        {props.tempUnit ? (
          <span>{max} °F</span>
        ) : (
          <span>{Math.round(((max - 32) * 5) / 9)} °C</span>
        )}
      </h5>
    </div>
  );
};

export default ShippingUPSBox;
